<div class="login-container">
  <!-- Lado esquerdo - Informações de conta inativa -->
  <div class="login-left">
    <div class="login-form-container">
      <div class="sispac-logo-section">
        <div class="sispac-logo-container">
          <div class="sispac-logo-wrap">
            <img
              *ngIf="isChristmasMode"
              src="../../../assets/img/christmas/Gemini_Generated_Image_rcto20rcto20rcto-removebg-preview.png"
              alt="Logo Natal"
              class="logo-image">
            <img
              *ngIf="!isChristmasMode"
              src="../../../assets/img/sispac-new/logo-sispac-new.png"
              alt="SISPAC"
              class="logo-image">
          </div>
          <div class="sispac-title" *ngIf="!isChristmasMode">
            <img
              src="../../../assets/img/sispac-new/nome-sispac-new.png"
              alt="SISPAC"
              class="title-image">
          </div>
        </div>
        <!-- <p class="system-description">
          Sistema de Controle de Procedimentos Administrativos Correcionais - SISPAC
        </p> -->
      </div>

      <!-- Título da seção -->
      <div class="form-header">
        <mat-icon class="warning-icon">warning</mat-icon>
        <h2>Conta Inativa</h2>
      </div>

      <!-- Informações da inativação -->
      <div class="inativacao-info" *ngIf="dadosInativacao">
        <mat-card class="info-card">
          <mat-card-content>
            <p><strong>Motivo:</strong> {{ dadosInativacao.motivo }}</p>
            <p><strong>Data da inativação:</strong> {{ formatarData(dadosInativacao.data_inativacao) }}</p>
            <p class="info-message">{{ dadosInativacao.mensagem }}</p>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Opções de ação -->
      <div class="action-options">
        <div class="option-card contact-option">
          <h3>Contatar Administrador</h3>
          <p>Se sua conta foi inativada manualmente ou você não consegue reativá-la, entre em contato conosco.</p>

          <button mat-stroked-button color="accent"
                  class="action-button full-width"
                  (click)="contartarAdministrador()"
                  [disabled]="isProgress">
            <mat-icon>support_agent</mat-icon>
            Contatar Suporte
          </button>
        </div>
      </div>

      <!-- Voltar ao login -->
      <div class="back-to-login">
        <button mat-button
                class="back-button"
                (click)="voltarLogin()"
                [disabled]="isProgress">
          <mat-icon>arrow_back</mat-icon>
          Voltar ao Login
        </button>
      </div>
    </div>
  </div>

  <!-- Lado direito - Seção de boas-vindas -->
  <div class="login-right">
    <div class="welcome-content">
      <div class="welcome-header">
        <h1>Reativação<br>de Conta</h1>
      </div>

      <div class="welcome-description">
        <p>Sua conta foi temporariamente inativada por motivos de segurança.</p>
        <p>Contate o administrador do sistema para obter suporte.</p>
      </div>

      <div class="security-info">
        <mat-icon>security</mat-icon>
        <p>Política de Segurança: Contas são automaticamente inativadas após 90 dias sem acesso para proteger seus dados.</p>
      </div>

      <div class="institutional-branding">
        <img
          src="../../../assets/img/sispac-new/logo-cge-e-estado-goias.png"
          alt="Controladoria-Geral do Estado e Governo de Goiás"
          class="branding-logo">
        <div class="branding-info">
          <p>Controladoria-Geral do Estado de Goiás</p>
          <p>Desenvolvimento e Gestão</p>
        </div>
      </div>
    </div>
  </div>
</div>
